import $ from "jquery"

/**
 * Scripts for matchHeight sections
 */
$('.js-match-height').matchHeight();
$('.js-match-height-market').matchHeight();

// section cta new - photo animation
// Select the element with the class 'img-person'
const imgPerson = document.querySelector('.img-person');

// Use the Intersection Observer API to observe the section
const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        // Check if the element is in the viewport
        if (entry.isIntersecting) {
            // Add the 'visible' class to trigger the animation
            entry.target.classList.add('visible');
            // Optionally stop observing the element after the animation starts
            observer.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.1 // The element is considered visible when 10% of it is in view
});

// Start observing the 'img-person' element
observer.observe(imgPerson);
